// extracted by mini-css-extract-plugin
export default {"root":"kd2H6","opening":"C9QXu","open":"ysYsz","closing":"kuMAp"};